export default {
  welcome: 'Welcome',
  home: 'Home',
  currentStore: 'Current Running Store',
  switchStore: 'Switch to the store',
  dashboard: 'Dashboard',
  region: 'Region',
  today: 'Today',
  yesterday: 'Yesterday',
  latest7Days: 'Latest 7 days',
  thisMonth: 'This month',
  previousMonth: 'Previous month',
  withinThreeMonths: 'Within three months',
  talking: 'Talking',
  unreplied: 'Unreplied',
  toProcess: 'To process',
  orderCount: 'Order Count',
  topProducts: 'Top Products',
  // actualSold: 'By Actual Sold',
  orderCount1: 'By Order Count',
  views: 'By Views',
  rejectedCount: 'By Rejected Count',
  buyerCount: 'By Buyer Count',
  new: 'New',
  pendingConfirm: 'pending confirm',
  pendingDispatch: 'pending dispatch',
  inDelivery: 'In delivery',
  inTransit: 'In transit',
  completed: 'Completed',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  submitted: 'Submitted',
  inProgress: 'In Progress',
  success: 'Success',
  listingId: 'Listing ID',
  title: 'Title',
  actualSold: 'Actual Sold',
  selectStore: '请选择切换的店铺！',
  switchSuccess: '切换成功！',
  within7Days: 'Within 7 days',
  within30Days: 'Within 30 days',
  cannot92Days: 'Cannot exceed 92 days',
  rejectedCount1: 'Rejected Count',
  buyerCount1: 'Buyer Count',
  views1: 'Views',
  GMV: 'GMV',
  currentLockStatus: 'Current lock status',
  Locked: 'Locked',
  Unlock: 'Unlock',
  toRemindPayment: 'To Remind Payment',
  toDispatch: 'To Dispatch',
  toProcessAftersale: 'To Process Aftersale',
  toProcessCancellation: 'To Process Cancellation',
  toReplyMessages: 'To Reply Messages',
  toReplyReviews: 'To Reply Reviews',
  violatingPolicyProducts: 'Violating Policy Products',
  toConfirmRestockInvitations: 'To Confirm Restock Invitations',
  toApplyRestockInvitations: 'To Apply Restock Invitations',
  toDispatchRestockApplications: 'To Dispatch Restock Boxes',
  doListTitle: 'To Do List',
  needToDealWith: 'Things you need to deal with',
  announcements: 'Announcements',
  businessOverview: 'Business Overview',
  more: 'More',
  newText: 'New',
  dateRange: 'Date Range',
  last7days: 'Last 7 days',
  last14days: 'Last 14 days',
  last30days: 'Last 30 days',
  thisWeek: 'This week',
  lastWeek: 'Last week',
  lastMonth: 'Last month',
  sortBy: 'Sort by',
  ordersQty: 'Order Qty',
  top5Products: 'Top 5 Products',
  sku: 'SKU',
  productName: 'Product name',
  vsPreviousPeriod: 'Vs. previous period',
  paidOrders: 'Paid Orders',
  averagePaidOrderValue: 'Average Paid Order Value',
  Visitors: 'Visitors',
  paidBuyers: 'Paid Buyers',
  paidConversionRate: 'Paid Conversion Rate',
  paidGmvTrend: 'Gross Revenue Trend',
  yourStoreClose: 'Your store is temporarily closed in certain country markets. During this closure, you will not receive any self-dispatch orders from those affected countries: ',
  yourStorePossible: 'Due to possible violations',
  yourStorePossible1: ', your store is locked in certain country markets. You can not add products and receive new orders from those affected countries: ',
  yourStorePossible2: 'Please contact official seller support team for any assistance.',
  goToSetting: 'Go to store settings',
  paidGmv: 'Paid GMV',
  grossRevenue: 'Gross Revenue',
  paidGmvTip: 'The total amount of the paid orders by buyers.',
  grossRevenueTip: 'Total product amount of paid orders, before deductions of any discounts or vouchers.',
  visitorsTip: 'The sum of unique users who viewed your products.',
  paidOrdersTip: 'The total orders paid by buyers.',
  paidBuyersTip: 'The sum of unique users who paid orders of your products.',
  averagePaidTip: 'The average amount of paid orders by buyers.',
  paidConversionTip: 'The percentage of visitors who paid orders of your products.',
  paidOrderQty: 'Paid Order Qty',
  remindMeDaily: 'Remind Me Daily',
  toImprovePerformanceMetrics: 'To Improve Performance Metrics',
  bestSellingProducts: 'Best-Selling Products',
  mostVisitedProducts: 'Most-Visited Products',
  pageviews: 'Pageviews',
  product: 'Product',
  crossStoreSpendSave: 'Cross-Store Spend & Save',
  message: 'Message',
  popup: {
    readAndAcknowledge: 'Acknowledged'
  },
  toProcessAftersaleOld: 'To Process Aftersale(Old)',
  toProcessAftersaleNew: 'To Process Aftersale(New)'
}
